// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"a4263cd6","791":"e5a89e62","841":"bb89c84f"}[chunkId] + ".chunk.js";
};